<ng-container *ngIf="content">
  <div class="settings-box" *ngIf="user$ | async as user">
    <div class="settings-box__header">
      <h2 class="settings-box__title">
        {{
          content?.fields?.resources
            | findResource: 'settings.yourInformationTitle'
        }}
      </h2>
      <a
        class="settings-box__edit"
        (click)="onEdit()"
        *ngIf="!edit && !delete"
        >{{
          content?.fields?.resources | findResource: 'settings.editLinkText'
        }}</a
      >
      <!-- <a class="settings-box__edit settings-box__edit--delete" (click)="onDelete()" *ngIf="!edit && !delete">{{
        content?.fields?.resources | findResource: 'settings.deleteLinkText'
      }}</a> -->
    </div>

    <form [formGroup]="basicInformation">
      <div class="basic-information">
        <div class="basic-information__column">
          <label class="basic-information__label">{{
            content?.fields?.resources | findResource: 'settings.firstName'
          }}</label>
          <div *ngIf="edit">
            <input
              class="basic-information__input"
              type="text"
              formControlName="firstName"
            />
          </div>
          <div *ngIf="!edit" class="basic-information__field-value">
            {{ user.firstName }}
          </div>
        </div>

        <div class="basic-information__column">
          <label class="basic-information__label">{{
            content?.fields?.resources | findResource: 'settings.lastName'
          }}</label>
          <div *ngIf="edit">
            <input
              class="basic-information__input"
              type="text"
              formControlName="lastName"
            />
          </div>
          <div *ngIf="!edit" class="basic-information__field-value">
            {{ user.lastName }}
          </div>
        </div>

        <div class="basic-information__column">
          <label class="basic-information__label">{{
            content?.fields?.resources | findResource: 'settings.email'
          }}</label>
          <div *ngIf="edit" title="Email address can't be changed!">
            <input
              class="basic-information__input"
              type="text"
              formControlName="email"
              readonly
              style="pointer-events: none"
            />
          </div>
          <div *ngIf="!edit" class="basic-information__field-value">
            {{ user.email }}
          </div>
        </div>
      </div>

      <div class="edit-actions" *ngIf="edit">
        <div *ngIf="basicInformation.invalid" class="errors">
          {{
            content?.fields?.resources
              | findResource: 'settings.yourInformationFormErrorMessage'
          }}
        </div>
        <div *ngIf="error" class="errors">{{ error }}</div>

        <button
          class="update"
          type="button"
          [ngClass]="{ 'update--loading': loading }"
          [disabled]="basicInformation.invalid || basicInformation.pristine"
          (click)="updateProfile()"
        >
          {{
            content?.fields?.resources
              | findResource: 'settings.yourInformationUpdateButtonText'
          }}
        </button>

        <a class="cancel" (click)="edit = false">{{
          content?.fields?.resources
            | findResource: 'settings.paymentMethodCancelUpdateText'
        }}</a>
      </div>
    </form>

    <div *ngIf="delete">
      <div class="delete-description">
        {{
          content?.fields?.resources
            | findResource: 'settings.deleteDescription'
        }}
      </div>
      <button
        class="delete"
        [ngClass]="{ 'delete--loading': deleting }"
        type="button"
        (click)="deleteAccount()"
        [disabled]="deleting"
      >
        {{
          content?.fields?.resources | findResource: 'settings.deleteAccount'
        }}
      </button>
      <a class="cancel" (click)="delete = false">{{
        content?.fields?.resources
          | findResource: 'settings.paymentMethodCancelUpdateText'
      }}</a>
      <div *ngIf="deleteError" class="errors errors--delete">
        {{ deleteError }}
      </div>
    </div>
  </div>
  <div class="settings-box" *ngIf="deleted">
    <h2 class="settings-box__title">
      {{ content?.fields?.resources | findResource: 'settings.accountDeleted' }}
    </h2>
  </div>
</ng-container>
